export const CabinetNavigation = [
    {
        id: 1,
        title: 'Bosh sahifa',
        icon: 'AiOutlineHome',
        navLink: '/dashboard'
    },
    // {
    //     id: 2,
    //     title: 'Variations',
    //     icon: 'VscSymbolVariable',
    //     navLink: '/variations'
    // }
]